/**
 * `buyerAuth.*` — buyer authentication (spec 34).
 *
 * Phone-OTP flow: requestOtp → verifyOtp → (new: register) → session.
 */
import { z } from "zod";
import { uuid, phoneIN } from "../_common.js";

export const requestOtpInput = z.object({
  storeSlug: z.string().min(1).max(64),
  phone: phoneIN,
});
export const requestOtpOutput = z.object({
  challengeId: uuid,
  expiresInSeconds: z.number().int(),
});

export const verifyOtpInput = z.object({
  storeSlug: z.string().min(1).max(64),
  challengeId: uuid,
  code: z.string().length(6),
});
export const verifyOtpOutput = z.object({
  outcome: z.enum(["existing-buyer", "new-phone"]),
  buyerId: uuid.nullable(),
});

export const registerInput = z.object({
  storeSlug: z.string().min(1).max(64),
  challengeId: uuid,
  name: z.string().trim().min(1).max(160),
  businessName: z.string().trim().min(1).max(160),
  gstin: z
    .string()
    .regex(/^[0-9]{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/, "invalid GSTIN")
    .optional(),
});
export const registerOutput = z.object({
  buyerId: uuid,
  customerId: uuid,
});

export const meInput = z.object({
  storeSlug: z.string().min(1).max(64),
});
export const meOutput = z
  .object({
    buyerId: uuid,
    name: z.string(),
    businessName: z.string(),
    /** Null when the buyer registered without one — checkout prefills it. */
    gstin: z.string().nullable(),
    phone: z.string(),
    status: z.string(),
  })
  .nullable();

export const logoutInput = z.object({
  storeSlug: z.string().min(1).max(64),
});
export const logoutOutput = z.object({ success: z.literal(true) });
